import { DraggableWrapper, ImageView, MultilineView } from "../components";
import Template3Image from "./text-heavy-carousel/template-3-image.png";

class BaseTemplate{
  constructor(){
    this.templateName = 'base'
  }

  getBackground(commonSettings){
    // if the commonSettings has the background_color key, return that value
    let value = this.getPropertyByStyleKey("background_color", commonSettings);
    if(value) {
      return {
        backgroundColor: value,
      }
    }
    // otherwise check if the commonSettings has the background key, and the value type is color
    value = this.getPropertyByStyleKey("background", commonSettings);
    if(value && value.type === "color") {
      return {
        backgroundColor: value.color,
      }
    }
    // check if the type is image
    if(value && value.type === "image") {
      return {
        backgroundImage: `url(${value.image})`,
        backgroundSize: "cover",
      }
    }
    // otherwise return an empty object
    return {}
  }

  renderSlideV2(slide, slideIndex, currentSlide, carouselLength, commonSettings, updateSlideElementPosition, updateSlideElementSize, setCurrentSlideElement, previewMode) {
    return (
        <div
          key={slide.key || slideIndex}
          className={"carousel-slide-container relative flex flex-col shrink-0 w-[400px] h-[500px] overflow-hidden bg-purple-50 " + (slideIndex !== currentSlide ? "hidden": "") + " index-" + slideIndex}
          style={this.getBackground(commonSettings)}
          >
          <div className={slide.className}>
            {
              this.render(slide, slideIndex, currentSlide, carouselLength, commonSettings, updateSlideElementPosition, updateSlideElementSize, setCurrentSlideElement, previewMode)
            }
          </div>
        </div>
    )
  }

  render(slide, slideIndex, currentSlide, carouselLength, commonSettings, updateSlideElementPosition, updateSlideElementSize, setCurrentSlideElement, previewMode) {
    return (
      <div>
      {
        slide.elements.map((element, elementIndex) => {
          return(
            <DraggableWrapper
              previewMode={previewMode}
              setCurrentSlideElement={setCurrentSlideElement}
              key={`${element?.key}-draggablewrapper-key-${elementIndex}-slide-${slideIndex}-${element?.type}}`}
              element={element}
              updateSlideElementSize={updateSlideElementSize}
              updateSlideElementPosition={updateSlideElementPosition}
              slideIndex={slideIndex}
              elementIndex={elementIndex}
              >
                <div className="handle w-full h-full"
                  onClick={() => setCurrentSlideElement({slideIndex: currentSlide, elementIndex: elementIndex, elementType: element.type})}
                  style={
                   {}
                  }
                  >
                  {element.type === "multiline" &&
                    <MultilineView
                      element={element}
                      getPropertyByStyleKey={(styleKey) => this.getPropertyByStyleKey(styleKey, commonSettings)}
                      getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
                    />
                  }
                  {
                    element.type === "image" && element.value ?
                    <ImageView element={element} /> : ""
                  }
                </div>
            </DraggableWrapper>
          )
        })
        }
        </div>
    )
  }

  getPropertyByStyleKey(styleKey, cs) {
    let commonSettings = cs;
    if(!cs) {
      commonSettings = this.common_settings;
    }
    if(!commonSettings) {
      return;
    }
    for(let i = 0; i < commonSettings.elements.length; i++) {
      if(commonSettings.elements[i].key === styleKey) {
        if(commonSettings.elements[i].key !== "background_color") {          
          return commonSettings.elements[i].value;
        }
        else{
          if(typeof commonSettings.elements[i].value === 'string'){
            return commonSettings.elements[i].value;
          }
          return commonSettings.elements[i].value.color;
        }
      }
    }
  }

  getValueByKey(key, cs) {
    let commonSettings = cs;
    if(!cs) {
      commonSettings = this.common_settings;
    }
    if(!commonSettings) {
      return;
    }
    for(let i = 0; i < commonSettings.elements.length; i++) {
      if(commonSettings.elements[i].key === key) {
        return commonSettings.elements[i].value;
      }
    }
  }

  duplicateSlide(slide, index) {
    let newSlide = JSON.parse(JSON.stringify(slide));
    if(index === 0){
      let el = {
        label: "Description",
        target_key: "description",
        value: "",
      }
      newSlide.elements.push(el)
    }

    this.slides = [
      ...this.slides.slice(0, index + 1),
      newSlide,
      ...this.slides.slice(index + 1)
    ]
    return newSlide;
  }

  getElementByType(type) {
    if(type === "text") {
      return {
        key : this.uuidv4(),
        label: "Title",
        target_key: "title",
        type: "multiline",
        value: "PLACE HOLDER TEXT",
        max_words: 7,
        rows: 2,
        position: {
          x: 10,
          y: 10,
        },
        className: "text-5xl leading-none font-bebas",
        style: {
          color: {
            key: "primary_color"
          },
          height: {
            value: "150px"
          },
          width: {
            value: "344px"
          },
          fontSize: {
            value: "20px"
          },
          fontWeight: {
            value: "bold"
          },
          textAlign: {
            value: "left"
          },
          fontFamily: {
            value: "Inter"
          },
        },
      }
    }
    if(type === "image") {
      return {
        key : this.uuidv4(),
        label: "Image(Recommended size 400 x 200)",
        target_key: "image",
        type: "image",
        value: Template3Image,
        position: {
          x: 12,
          y: 81,
        },
        style: {
          height: {
            value: "200px"
          },
          width: {
            value: "344px"
          }
        },
        className: "object-cover w-full rounded-xl"
      }
    }
  }

  addElement(type, template, carousel, currentSlide, setCarousel){
    let newElement = template?.getElementByType(type);
    if(newElement) {
      let slides = carousel.slides;
      let slide = slides[currentSlide];
      slide.elements.push(newElement);
      slides[currentSlide] = slide;
      setCarousel({
        ...carousel,
        slides: slides
      })

    }
  }

  duplicateElement(carousel, currentSlide, currentSlideElement, setCarousel){
    let slide = carousel.slides[currentSlide];
    let oldElement = slide.elements[currentSlideElement.elementIndex];
    let newElement = JSON.parse(JSON.stringify(oldElement));
    newElement.key = this.uuidv4();
    slide.elements.push(newElement);
    let slides = carousel.slides;
    slides[currentSlide] = slide;

    setCarousel({
      ...carousel,
      slides: slides
    })
  }

  deleteElement(carousel, currentSlide, currentSlideElement, setCarousel){
    let slide = carousel.slides[currentSlide];
    slide.elements.splice(currentSlideElement.elementIndex, 1);
    // change the key of the element
    slide.elements = slide.elements.map((element, index) => {
      element.key = this.uuidv4();
      return element;
    })
    let slides = carousel.slides;
    slides[currentSlide] = slide;
    setCarousel({
      ...carousel,
      slides: slides
    })
  }

  updateElementStyle(carousel, currentSlide, currentSlideElement, styleKey, value, setCarousel){
    let slide = JSON.parse(JSON.stringify(carousel.slides[currentSlide]));
    // check if styleKey exists in the element
    if(slide.elements[currentSlideElement.elementIndex]?.style && !slide.elements[currentSlideElement.elementIndex]?.style[styleKey]) {
      slide.elements[currentSlideElement.elementIndex].style[styleKey] = {
        value: value
      }
    } else {
      slide.elements[currentSlideElement.elementIndex].style[styleKey].value = value;
    }

    let newSlides = [
      ...carousel.slides.slice(0, currentSlide),
      slide,
      ...carousel.slides.slice(currentSlide + 1)
    ]
    setCarousel({
      ...carousel,
      slides: newSlides
    })
  }

  uuidv4() {
    // eslint-disable-next-line no-mixed-operators
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
  }
}

export default BaseTemplate;
